// #region Imports
import { Dialog } from '@radix-ui/themes';
import { FaBug, FaComment, FaTimes } from 'react-icons/fa';
import { AZButton } from '../AZButton';
import './AZFeedback.css';
// #endregion

// #region Types
interface ChoiceScreenProps {
  onSelect: (choice: 'feedback' | 'bug') => void;
  onClose: () => void;
}
// #endregion

// #region Component
const ChoiceScreen = ({ onSelect, onClose }: ChoiceScreenProps) => {
  return (
    <>
      {/* #region Header */}
      <div className="az-feedback-header">
        <div className="az-feedback-title-group">
          <Dialog.Title
            className="az-feedback-title"
            style={{ color: 'var(--az-palette-ice-white)' }}
          >
            Your opinion matters
          </Dialog.Title>
          <p className="az-feedback-disclaimer">How can I help you today?</p>
        </div>
        <div className="az-feedback-header-buttons">
          <AZButton
            type="button"
            variant="ghost"
            className="az-feedback-icon-button"
            onClick={onClose}
            aria-label="Close"
          >
            <FaTimes aria-hidden="true" />
          </AZButton>
        </div>
      </div>
      {/* #endregion */}

      {/* #region Cards */}
      <div className="az-feedback-cards">
        <button type="button" className="az-feedback-card" onClick={() => onSelect('bug')}>
          <FaBug className="az-feedback-card-icon" aria-hidden="true" />
          <div>
            <p className="az-feedback-card-title">Report a bug</p>
            <p className="az-feedback-card-desc">Something is broken or not working as expected</p>
          </div>
        </button>
        <button type="button" className="az-feedback-card" onClick={() => onSelect('feedback')}>
          <FaComment className="az-feedback-card-icon" aria-hidden="true" />
          <div>
            <p className="az-feedback-card-title">Share feedback</p>
            <p className="az-feedback-card-desc">Tell us what you think or suggest improvements</p>
          </div>
        </button>
      </div>
      {/* #endregion */}
    </>
  );
};
// #endregion

// #region Display Name
ChoiceScreen.displayName = 'ChoiceScreen';
// #endregion

export { ChoiceScreen };
